var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("address", [
    _vm.storeAddress.name
      ? _c("span", [
          _vm._v("\n    " + _vm._s(_vm.storeAddress.name) + ","),
          _c("br"),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.storeAddress.address1
      ? _c("span", [
          _vm._v("\n    " + _vm._s(_vm.storeAddress.address1) + ","),
          _c("br"),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.storeAddress.address2
      ? _c("span", [
          _vm._v("\n    " + _vm._s(_vm.storeAddress.address2) + ","),
          _c("br"),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.storeAddress.address3
      ? _c("span", [
          _vm._v("\n    " + _vm._s(_vm.storeAddress.address3) + ","),
          _c("br"),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.storeAddress.address4
      ? _c("span", [
          _vm._v("\n    " + _vm._s(_vm.storeAddress.address4) + ","),
          _c("br"),
        ])
      : _vm._e(),
    _vm._v("\n  " + _vm._s(_vm.storeAddress.postcode)),
    _c("br"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }